import type { MaybeRefOrGetter } from 'vue';
import type { NavigationGuard } from 'vue-router';
import { useEventListener } from '@vueuse/core';
import { toValue } from 'vue';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import { useDevtoolsFlag } from './use-devtools-flag';

export function useNavigationGuard(hasChanges: MaybeRefOrGetter<boolean>, guard: NavigationGuard) {
	const { isEnabled: isBeforeUnloadEnabled } = useDevtoolsFlag('prevent-before-unload');

	useEventListener(window, 'beforeunload', (event) => {
		if (import.meta.dev && !isBeforeUnloadEnabled.value) return;

		if (toValue(hasChanges)) {
			event.preventDefault();
		}
	});

	onBeforeRouteUpdate(guard);
	onBeforeRouteLeave(guard);
}
